module.exports = __webpack_public_path__ + "static/media/business.3c066995.png";